import React from 'react';
import { Col, Row, FormLabel, Button } from 'react-bootstrap';
import { Form } from 'formik';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  FormGroupRadioField,
  FormInputField,
  FormInputFieldType,
  FormSelectField,
} from '../../common/components/formFields';
import { constantToSelect } from '../../common/helpers';
import { AdminRoleName } from '../../constants/AdminRole';
import { AdminStatusName } from '../../constants/AdminStatus';
import CommonErrorLabel from '../../common/components/CommonErrorLabel';
import ComponentCard from '../../common/components/cards/ComponentCard';

const adminStatuses = constantToSelect(AdminStatusName);
const adminRoles = constantToSelect(AdminRoleName);

function AdminForm({ title, values }) {
  const validateErrors = useSelector((state) => state.admins.get('validateErrors'));
  const oldEmail = useSelector((state) => state.admins.get('oldEmail'));
  const { id } = useParams();

  return (
    <ComponentCard title={title}>
      <Form noValidate>
        <Row>
          <Col md="4">
            <FormInputField name="firstName" label="First Name" required />
          </Col>
          <Col md="4">
            <FormInputField name="lastName" label="Last Name" required />
          </Col>
          <Col md="4">
            <FormInputField name="email" label="Email Address" type="email" required />
            {oldEmail === values?.email && (
              <CommonErrorLabel
                value={validateErrors?.email}
                classNames="custom-email-error-label"
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <FormInputField
              name="password"
              label="Password"
              type={FormInputFieldType.PASSWORD}
              required={!id}
            />
          </Col>
          <Col md="4">
            <FormInputField
              name="passwordRepeat"
              label="Repeat Password"
              type={FormInputFieldType.PASSWORD}
              required={!id}
            />
          </Col>
          <Col md="4">
            <FormSelectField name="status" label="Status" options={adminStatuses} required />
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <FormLabel className="label-required">Role</FormLabel>
            <FormGroupRadioField name="role" label="role" radios={adminRoles} />
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Button className="mt-4 float-end rounded-pill btn-primary" type="submit">
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </ComponentCard>
  );
}

export default AdminForm;
